import { type FC, useState } from 'react'

import { LinkText } from '@core/components/common/Button'
import { ArrowLeftIcon } from '@core/components/icons'
import { useLayout } from '@core/contexts/layout'
import { colors } from '@core/helpers'

import { ChangePasswordSuccessContent } from '../ChangePassword/ChangePasswordSuccessContent'
import { LoginLayout } from '../LoginLayout'
import { ConfirmMessageCode } from './ConfirmMessageCode'

interface Props {
  documentNumber: string
  documentType: number
  email: string
  newPassword: string
  token: string
}

export const ConfirmMessage: FC<Props> = ({
  documentNumber,
  documentType,
  email,
  newPassword,
  token
}) => {
  const { isMobile, isDesktop } = useLayout()

  const [isProcessSuccess, setIsProcessSuccess] = useState(false)

  if (isProcessSuccess) {
    return (
      <LoginLayout
        height='100vh'
        title='Contraseña cambiada - Portal aviva'
        maxWidthDesktop='72rem'
      >
        <ChangePasswordSuccessContent height='90vh' />
      </LoginLayout>
    )
  }

  return (
    <LoginLayout title='Correo enviado - Portal aviva' maxWidthDesktop='72rem'>
      <LinkText
        typographyProps={{
          fontWeight: 600
        }}
        customIcon={(color, size) => <ArrowLeftIcon size={size} color={colors.primary_darkest} />}
        href='/autenticacion/iniciar-sesion/restablecer'
        text='Atrás'
        iconUbi='left'
        color={colors.primary_darkest}
        styleContainer={{
          marginTop: '2.4rem',
          marginBottom: isMobile ? '3.4rem' : undefined,
          paddingLeft: isDesktop ? '10.4rem' : undefined
        }}
      />

      <ConfirmMessageCode
        documentNumber={documentNumber}
        documentType={documentType}
        email={email}
        newPassword={newPassword}
        onContinue={() => setIsProcessSuccess(true)}
        token={token}
      />
    </LoginLayout>
  )
}
